import React from 'react';
import useChatStore from '@core/stores/useChatStore'; // Importing the custom hook for managing the store

// Defining the types for the component props
interface PresentationModeProps {
    children: React.ReactNode;
    reverse?: boolean;
}

export const PresentationMode: React.FC<PresentationModeProps> = ({
    children,
    reverse = false,
}) => {
    const presentationMode = useChatStore((state) => state.presentationMode);

    // Check if the presentation mode matches the 'reverse' flag condition
    if ((reverse && !presentationMode) || (!reverse && presentationMode)) {
        // If the condition matches, render the children
        return <>{children}</>;
    }

    // If the condition doesn't match, return null (nothing rendered)
    return null;
};
